export const HELLO_BAR_ACTION_ID = "CTA.ARTICLE_STUDENT_LOANS";
